<template>
    <div >
        <el-card>
            <el-row>
                <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>知识百科</el-breadcrumb-item>
                    <el-breadcrumb-item>我的百科</el-breadcrumb-item>
                </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row >
                <div style="float:left;width: 100%;">
                    <el-tabs type="card" @tab-click="handleClick">
                        <el-tab-pane label="我发布的" @click="mySend()">
                            <el-row style="margin-top:16px;">
                                <el-col :span="4">
                                    <el-input size="small" v-model="title" placeholder="请输入标题">
                                        <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
                                </el-col>
                                <!-- <el-col :span="2">
                                    <el-button size="small" @click="addWikiShadow">添加百科</el-button>
                                </el-col> -->
                                <el-col :span="18">
                                    <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="pageSizes"
                                    :page-size="pagesize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="totalCount"
                                    style="float:right"
                                    ></el-pagination>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small">
                                    <el-table-column prop="KnowledgeTitle" label="标题"></el-table-column>
                                    <el-table-column prop="AddUserName" label="发送人"></el-table-column>
                                    <el-table-column label="类型"><template slot-scope="scope">{{ scope.row.Type==0?'添加':(scope.row.Type==1?'编辑':'添加') }}</template></el-table-column>
                                    <el-table-column prop="AddTime" label="发送时间"></el-table-column>
                                    <el-table-column prop="LastEditTime" label="最后修改时间"></el-table-column>
                                    <!-- <el-table-column :label="send?'百科状态':(edit?'百科状态':'')">{{cope.row.AuditStatus==1?'审核中':(scope.row.AuditStatus==2?'审核通过':(scope.row.AuditStatus==2?'审核退回':'编辑中'))}} </el-table-column> -->
                                    <el-table-column prop="AuditTime" label="审核时间"></el-table-column>
                                    <el-table-column prop="AuditNote" label="退回原因"></el-table-column>
                                    <el-table-column label="操作" fixed="right" :span="8">
                                        <template  slot-scope="scope" >
                                            <el-button type="text" @click='bindWiki(scope.row)'>查看</el-button>
                                            <!-- <el-button type="text" @click='editWiki(scope.row)'>编辑</el-button> -->
                                            <el-button type="text" @click='lookShadow(scope.row)'>修改记录</el-button>
                                            <el-button type="text" style="color:red;" @click='delWiki(scope.row)'>删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="我编辑的" @click="myEdit()">
                            <el-row style="margin-top:16px;">
                                <el-col :span="4">
                                    <el-input size="small" v-model="title" placeholder="请输入标题">
                                        <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
                                </el-col>
                                <!-- <el-col :span="2">
                                    <el-button size="small" @click="addWikiShadow">添加百科</el-button>
                                </el-col> -->
                                <el-col :span="18">
                                    <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="pageSizes"
                                    :page-size="pagesize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="totalCount"
                                    style="float:right"
                                    ></el-pagination>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small">
                                    <el-table-column prop="KnowledgeTitle" label="标题"></el-table-column>
                                    <el-table-column prop="AddUserName" label="发送人"></el-table-column>
                                    <el-table-column label="类型"><template slot-scope="scope">{{ scope.row.Type==0?'添加':(scope.row.Type==1?'编辑':'添加') }}</template></el-table-column>
                                    <el-table-column prop="AddTime" label="发送时间"></el-table-column>
                                    <el-table-column prop="LastEditTime" label="最后修改时间"></el-table-column>
                                    <!-- <el-table-column :label="send?'百科状态':(edit?'百科状态':'')">{{cope.row.AuditStatus==1?'审核中':(scope.row.AuditStatus==2?'审核通过':(scope.row.AuditStatus==2?'审核退回':'编辑中'))}} </el-table-column> -->
                                    <el-table-column prop="AuditTime" label="审核时间"></el-table-column>
                                    <el-table-column prop="AuditNote" label="退回原因"></el-table-column>
                                    <el-table-column label="操作" fixed="right" :span="8">
                                        <template  slot-scope="scope" >
                                            <el-button type="text" @click='bindWiki(scope.row)'>查看</el-button>
                                            <!-- <el-button type="text" @click='editWiki(scope.row)'>编辑</el-button> -->
                                            <el-button type="text" @click='lookShadow(scope.row)'>修改记录</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="草稿箱" @click="myDraft()">
                            <el-row style="margin-top:16px;">
                                <el-col :span="4">
                                    <el-input size="small" v-model="title" placeholder="请输入标题">
                                        <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
                                </el-col>
                                <!-- <el-col :span="2">
                                    <el-button size="small" @click="addWikiShadow">添加百科</el-button>
                                </el-col> -->
                                <el-col :span="18">
                                    <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="pageSizes"
                                    :page-size="pagesize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="totalCount"
                                    style="float:right"
                                    ></el-pagination>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small">
                                    <el-table-column prop="KnowledgeTitle" label="标题"></el-table-column>
                                    <el-table-column prop="SendUserName" label="发送人"></el-table-column>
                                    <el-table-column label="类型"><template slot-scope="scope">{{ scope.row.Type==0?'添加':(scope.row.Type==1?'编辑':'添加') }}</template></el-table-column>
                                    <el-table-column prop="SendTime" label="发送时间"></el-table-column>
                                    <el-table-column prop="LastEditTime" label="最后修改时间"></el-table-column>
                                    <!-- <el-table-column :label="send?'百科状态':(edit?'百科状态':'')">{{cope.row.AuditStatus==1?'审核中':(scope.row.AuditStatus==2?'审核通过':(scope.row.AuditStatus==2?'审核退回':'编辑中'))}} </el-table-column> -->
                                    <el-table-column prop="AuditTime" label="审核时间"></el-table-column>
                                    <el-table-column prop="AuditNote" label="退回原因"></el-table-column>
                                    <el-table-column label="操作" fixed="right" :span="8">
                                        <template  slot-scope="scope" >
                                            <el-button type="text" @click='bindShadow(scope.row)'>查看</el-button>
                                            <el-button type="text" @click='sendAudit(scope.row)'>发送审核</el-button>
                                            <!-- <el-button type="text" @click='editWikiShadow(scope.row)'>编辑</el-button> -->
                                            <el-button type="text" style="color:red;" @click='delShadow(scope.row)'>删除</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                        <el-tab-pane label="审核中" @click="myAudit()">
                            <el-row style="margin-top:16px;">
                                <el-col :span="4">
                                    <el-input size="small" v-model="title" placeholder="请输入标题">
                                        <el-button slot="append" icon="el-icon-search" @click="SearchByName"></el-button>
                                    </el-input>
                                </el-col>
                                <el-col :span="2">
                                    <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
                                </el-col>
                                <!-- <el-col :span="2">
                                    <el-button size="small" @click="addWikiShadow">添加百科</el-button>
                                </el-col> -->
                                <el-col :span="18">
                                    <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page="currentPage"
                                    :page-sizes="pageSizes"
                                    :page-size="pagesize"
                                    layout="total, sizes, prev, pager, next, jumper"
                                    :total="totalCount"
                                    style="float:right"
                                    ></el-pagination>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                <el-table :data="tableData" style="width: 100%" v-loading="loading" size="small">
                                    <el-table-column prop="KnowledgeTitle" label="标题"></el-table-column>
                                    <el-table-column prop="SendUserName" label="发送人"></el-table-column>
                                    <el-table-column label="类型"><template slot-scope="scope">{{ scope.row.Type==0?'添加':(scope.row.Type==1?'编辑':'添加') }}</template></el-table-column>
                                    <el-table-column prop="SendTime" label="发送时间"></el-table-column>
                                    <el-table-column prop="LastEditTime" label="最后修改时间"></el-table-column>
                                    <!-- <el-table-column :label="send?'百科状态':(edit?'百科状态':'')">{{cope.row.AuditStatus==1?'审核中':(scope.row.AuditStatus==2?'审核通过':(scope.row.AuditStatus==2?'审核退回':'编辑中'))}} </el-table-column> -->
                                    <el-table-column prop="AuditTime" label="审核时间"></el-table-column>
                                    <el-table-column prop="AuditNote" label="退回原因"></el-table-column>
                                    <el-table-column label="操作" fixed="right" :span="8">
                                        <template  slot-scope="scope" >
                                            <el-button type="text" @click='bindShadow(scope.row)'>查看</el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                </el-col>
                            </el-row>
                        </el-tab-pane>
                    </el-tabs>
                    <!-- <el-tag class="tagRight" :effect="send?'dark':''" @click="mySend()">我发布的</el-tag>
                    <el-tag class="tagRight" :effect="edit?'dark':''" @click="myEdit()">我编辑的</el-tag>
                    <el-tag class="tagRight" :effect="draft?'dark':''" @click="myDraft()">草稿箱</el-tag>
                    <el-tag class="tagRight" :effect="audit?'dark':''" @click="myAudit()">审核中</el-tag> -->
                </div>
            </el-row>
        </el-card>
    </div>    
</template>
<script>
     import { GetKnowledgeAuditPage,GetKnowledgeContentDescry,GetSingleKnowledgeShadow,GetSingleKnowledge,UpdateKnowledgewShadow,UpdateKnowledgewAndShadow,GetKnowledgePage,DeleteKnowledge  } from "../../until/ZeusApiSDK/Logic/WikiLogic";
     import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
     import { ImageAddDomain  } from "../../until/ZeusApiSDK/Logic/ImageStr";  
     import { timeFormate  } from "../../until/Common";
     export default {
        data() {
          return {
            totalCount:0,//默认数据总数
            pagesize:20,//每页的数据条数
            currentPage:1,//默认开始页面
            pageSizes:[1,10, 20, 50, 100, 200],//可选数据
            input:"",
            title: '',
            loading: true,
            currentRole:{},//当前角色
            currentUser:{},//当前用户
            wikiShadowModel:{},//退回时获取百科影子数据信息
            tableData: [],
            send:false,//发布
            edit:false,//编辑
            draft:true,//草稿箱
            audit:false,//审核中
            status:'send',//当前状态 默认为草稿箱
          };
        } ,
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                return 'th';
                }
                return '';
            },
            //获取当前用户
            getCurrentUser:function(){
                var userinfo = window.sessionStorage.getItem("userinfo");
                userinfo = JSON.parse(Decrypt(userinfo));
                this.currentUser = userinfo;
            },
            //获取当前角色
            getCurrentRole:function(){
                var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
                this.currentRole = JSON.parse(Decrypt(currentUserRole));
            },
            //搜索数据
            SearchByName:function(){
                this.currentPage=1;
                //重新获取数据
                this.getShadowList();
            },
            //刷新
            Refresh:function(){
                this.getShadowList();
            },
            //获取数据列表
            getShadowList:async function(){
                this.loading = true;
                //构造参数
                var predicates=[
                {
                    Field:"IsDelete", 
                    Value:"0", 
                    Oper:"eq", 
                    IsAnd:1
                }];
                if(this.status=='draft'){
                    //草稿箱
                    predicates.push({Field:"AuditStatus", Value:'0,3', Oper:"in", IsAnd:1 });
                    // //如果不是管理员显示本人发送
                    if(this.currentRole.Key!='admin'){
                        // predicates.push({Field:"SendUserID", Value:this.currentUser.UserId, Oper:"eq", IsAnd:1 });
                        predicates.push({Field:"SendUserID", Value:this.currentUser.UserName, Oper:"eq", IsAnd:1 });
                    } 
                }
                else if(this.status=='send'){
                    //我发布的
                    //如果不是管理员显示本人发送
                    if(this.currentRole.Key!='admin'){
                        predicates.push({Field:"AddUserID", Value: this.currentUser.UserName, Oper:"eq", IsAnd:1 });
                    } 
                }
                else if(this.status=='edit'){
                    //我编辑的
                    //predicates.push({Field:"EditUserIDs", Value:this.currentUser.UserId, Oper:"contain", IsAnd:1 });
                    //如果不是管理员显示本人发送
                    if(this.currentRole.Key!='admin'){
                        predicates.push({Field:"EditUserIDs", Value: this.currentUser.UserName, Oper:"eq", IsAnd:1 });
                    } 
                }
                else if(this.status=='audit'){
                    //审核中
                    predicates.push({Field:"AuditStatus", Value:'1', Oper:"eq", IsAnd:1 });
                    // //如果不是管理员显示本人发送
                    if(this.currentRole.Key!='admin'){
                        predicates.push({Field:"SendUserID", Value:this.currentUser.UserName, Oper:"eq", IsAnd:1 });
                    } 
                }
                
                //搜索条件是否为空      
                if (this.title!=null&&this.title!='')
                {
                    predicates.push({ Field:"KnowledgeTitle", Value:this.title, Oper:"contains", IsAnd:1 });
                }

                //我发布的/我编辑的
                if(this.status=='send'||this.status=='edit'){
                    
                    //草稿箱/审核中列表
                    await GetKnowledgePage(predicates,this.currentPage,this.pagesize,'AddTime','desc').then(res=>{
                        this.totalCount=res.TotalCount;
                        this.tableData=res.DataList;
                        this.loading = false;
                    });
                }
                else {
                    //草稿箱/审核中列表
                    await GetKnowledgeAuditPage(predicates,this.currentPage,this.pagesize,'SendTime','desc').then(res=>{
                        this.totalCount=res.TotalCount;
                        this.tableData=res.DataList;
                        this.loading = false;
                    });
                }
                
            },
            //选择每页条数
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pagesize = val;
                //重新获取列表数据
                this.getShadowList();
            },
            //跳转到第几页页面
            handleCurrentChange(val) {
                this.currentPage = val;
                //重新获取列表数据
                this.getShadowList();
            },
            //查看百科影子详情
            bindShadow:function(data){
                //跳转到查看详情页面
                this.$router.push('/Wiki/BindShadow?id='+data.ID+'&name=我的百科');
            },
            //查看百科详情
            bindWiki:function(data){
                //跳转到查看详情页面
                this.$router.push('/Wiki/BindWiki?id='+data.KnowledgeID+'&name=我的百科');
            },
            //查看修改记录
            lookShadow:function(data){
                //跳转到对比公告页面
                this.$router.push('/Wiki/EditRecord?id='+data.KnowledgeID+'&title=我的百科'+'&name='+data.KnowledgeTitle);
            },
            //审核通过当前数据
            sendAudit:function(data){
                // var id=data.ID;
                //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                this.$confirm('确定发送审核吗', '审核', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                    GetSingleKnowledgeShadow(data.ID).then(res=>{
                        this.wikiShadowModel=res;
                        this.wikiShadowModel.AuditUserID=this.currentUser.UserName;
                        this.wikiShadowModel.AuditUserName=this.currentUser.TrueName;
                        this.wikiShadowModel.AuditTime=timeFormate(new Date());
                        this.wikiShadowModel.AuditStatus=1;
                        //更新百科影子
                        UpdateKnowledgewAndShadow(this.wikiShadowModel.ID,this.wikiShadowModel).then(data=>{
                            if(data==true){
                                this.$message({
                                    type: 'success',
                                    message: '发送成功'
                                });
                                //获取待审核列表
                                this.getShadowList();
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: '发送失败'
                                });
                            }
                        });
                    });
                    
                }).catch(() => {
                    //取消    
                });
            },
            //审核退回当前数据
            setShadowID:async function(data){
                var id=data.ID;
                var status=data.AuditStatus;
                this.$prompt('退回原因', '审核退回', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(({value}) => {
                    //提交
                    if(value==null||value==''){
                        this.$message({
                            type: 'error',
                            message: '请输入退回原因'
                        });
                        return false;
                    }
                    //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                    GetSingleKnowledgeShadow(id).then(res=>{
                        this.wikiShadowModel=res;
                        var status=this.wikiShadowModel.AuditStatus;
                        this.wikiShadowModel.AuditUserID=this.currentUser.UserName;
                        this.wikiShadowModel.AuditUserName=this.currentUser.TrueName;
                        this.wikiShadowModel.AuditTime=timeFormate(new Date());
                        this.wikiShadowModel.AuditStatus=3;
                        this.wikiShadowModel.AuditNote=value;
                        //更新百科影子
                        UpdateKnowledgewShadow(this.wikiShadowModel.ID,this.wikiShadowModel).then(data=>{
                            if(data==true){
                                this.$message({
                                    type: 'success',
                                    message: '退回成功'
                                });
                                //获取待审核列表
                                this.getShadowList();
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: '退回失败'
                                });
                            }
                        });
                    });
                    
                }).catch(() => {
                    //取消    
                });
            },
            //添加百科
            addWikiShadow:function(){
            },
            // 编辑/添加百科
            editWiki:function(data){
                //编辑/添加百科
                this.$router.push('/EditWiki?id='+data.KnowledgeID);
            },
            // 编辑/添加百科影子
            editWikiShadow:function(data){
                //编辑/添加百科影子
                this.$router.push('/EditWikiShadow?id='+data.ID);
            },
            //我发布的项目删除百科
            delWiki:function(data){
                //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                this.$confirm('确定删除当前百科吗', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                    //获取百科详情
                    GetSingleKnowledge(data.KnowledgeID).then(res=>{
                        //删除当前百科和所有影子
                        res.IsDelete=1;
                        res.DeleteTime=timeFormate(new Date());
                        DeleteKnowledge(data.KnowledgeID,res).then(result=>{
                            if(result){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                                //获取数据列表
                                this.getShadowList();
                            }
                            else{
                                this.$message({
                                    type: 'error',
                                    message: '删除失败'
                                });
                            }
                        });
                    });
                    
                }).catch(() => {
                    //取消    
                });
            },
            //草稿箱 删除百科影子
            delShadow:function(data){
                //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                this.$confirm('确定删除当前百科吗', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                    //获取百科影子详情
                    GetSingleKnowledgeShadow(data.ID).then(res=>{
                        //删除当前百科和所有影子
                        res.IsDelete=1;
                        res.DeleteTime=timeFormate(new Date());
                        UpdateKnowledgewShadow(data.ID,res).then(result=>{
                            if(result){
                                this.$message({
                                    type: 'success',
                                    message: '删除成功'
                                });
                                //获取数据列表
                                this.getShadowList();
                            }
                            else{
                                this.$message({
                                    type: 'error',
                                    message: '删除失败'
                                });
                            }
                        });
                    });
                    
                }).catch(() => {
                    //取消    
                });
            },
            //点击不同按钮
            handleClick(tab, event) {
                this.loading=true;
                if(tab.label=="我发布的"){
                    this.status='send';
                }
                else if(tab.label=="我编辑的"){
                    this.status='edit';
                }
                else if(tab.label=="草稿箱"){
                    this.status='draft';
                }
                else if(tab.label=="审核中"){
                    this.status='audit';
                }
                else{
                    //我发布的
                    this.status='send';
                }
                //获取数据列表
                this.getShadowList();
            }
        },
        //页面进入加载事件
        created:function(){
            //获取当前用户
            this.getCurrentUser();
            //获取当前角色
            this.getCurrentRole();
            //获取数据列表
            this.getShadowList();
        },
      };
</script>
<style lang="less" scoped>
    .fl{
        float: right;
        margin-right:20px;
    }
    .fy{
        text-align:center;
        margin-top:30px;
    }
    .title{
        height:100%;
    }
    .msgBox{
        width:60% !important;
        height:70%;
    }
    .tagRight{
        margin-right:10px;
    }
    .show{
        display: block;
    }
    .hidden{
        display: none;;
    }
</style>
